export const EU_OMNIBUS_COUNTRIES_KEY = "euOmnibusCountries";
export const DEAL_BANNER_STORES_KEY = "dealBannerStores";
